// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1tCFP","large":"styles_large__3shok"};